var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_4457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8.63143C5.74312 8.63143 5.97628 8.53485 6.14818 8.36294C6.32009 8.19104 6.41667 7.95788 6.41667 7.71476C6.41667 7.47165 6.32009 7.23849 6.14818 7.06658C5.97628 6.89467 5.74312 6.7981 5.5 6.7981C5.25689 6.7981 5.02373 6.89467 4.85182 7.06658C4.67991 7.23849 4.58334 7.47165 4.58334 7.71476C4.58334 7.95788 4.67991 8.19104 4.85182 8.36294C5.02373 8.53485 5.25689 8.63143 5.5 8.63143ZM8.25 4.50643C8.49312 4.50643 8.72628 4.60301 8.89818 4.77491C9.07009 4.94682 9.16667 5.17998 9.16667 5.4231V10.0064C9.16667 10.2495 9.07009 10.4827 8.89818 10.6546C8.72628 10.8265 8.49312 10.9231 8.25 10.9231H2.75C2.50689 10.9231 2.27373 10.8265 2.10182 10.6546C1.92991 10.4827 1.83334 10.2495 1.83334 10.0064V5.4231C1.83334 5.17998 1.92991 4.94682 2.10182 4.77491C2.27373 4.60301 2.50689 4.50643 2.75 4.50643H3.20834V3.58976C3.20834 2.98197 3.44978 2.39908 3.87955 1.96931C4.30932 1.53954 4.89221 1.2981 5.5 1.2981C5.80095 1.2981 6.09895 1.35737 6.37699 1.47254C6.65502 1.58771 6.90765 1.75651 7.12046 1.96931C7.33326 2.18211 7.50206 2.43474 7.61723 2.71278C7.73239 2.99082 7.79167 3.28882 7.79167 3.58976V4.50643H8.25ZM5.5 2.21476C5.13533 2.21476 4.78559 2.35963 4.52773 2.61749C4.26987 2.87535 4.125 3.22509 4.125 3.58976V4.50643H6.875V3.58976C6.875 3.22509 6.73014 2.87535 6.47227 2.61749C6.21441 2.35963 5.86468 2.21476 5.5 2.21476Z",
    fill: "#5881FE",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_4457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0 0.839844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.8e65fb05533427b0942429923caae9cc.svg";
export { ForwardRef as ReactComponent };